import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import DanhDachIcloudApi from "../../../../service/QuanTriHeThong/DanhDachIcloudApi";
import { Tab, Tabs } from "react-bootstrap";
import { getDate } from "utils/formatDate";
import moment from "moment";

export const ThongTinChiTiet = (props) => {
  const [dataView, setDataView] = useState({});
  const [dataLichSu, setDataLichSu] = useState([]);
  const [dataHDLienKet, setDataHDLienKet] = useState([]);
  useEffect(() => {
    DanhDachIcloudApi.lstLichSuSuaTaiKhoan(props.data.Id).then((response) => {
      setDataLichSu(response.data);
    });
    DanhDachIcloudApi.lstHopDongLienKet(props.data.Id).then((response) => {
      setDataHDLienKet(response.data);
    });
  }, []);
  useEffect(() => {
    if (typeof props.data.Id != "undefined" && props.data.Id > 0) {
      setDataView(props.data);
    }
  }, [props.data.Id]);
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-file-document"></i>
          </span>
          Chi tiết Icloud
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div
                aria-labelledby="heading61"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <ul className="list-detailHD">
                          <li>
                            Số điện thoai: <b>{dataView.SoDienThoai}</b>
                          </li>
                          <li>
                            {" "}
                            Hạn chế: &nbsp;&nbsp;
                            {dataView.IsHanChe == true && <b>Có</b>}
                            {dataView.IsHanChe == false && <b>Không</b>}
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="list-detailHD">
                          <li>
                            Tên tài khoản: <b>{dataView.TenTaiKhoan}</b>
                          </li>
                          <li>
                            Mật khẩu: <b>{dataView.MatKhau}</b>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-12">
                        <ul className="list-detailHD">
                          <li>
                            Ghi chú: <b>{dataView.GhiChu}</b>
                          </li>
                        </ul>
                      </div>
                    </div>{" "}
                    <div className="tab-detail-hd">
                      <Tabs className="tab-detail-mm">
                        <Tab
                          eventKey="hdlienket"
                          title={<h4 className="nav-link">HĐ liên kết</h4>}
                        >
                          <div
                            className="table-mobile sticky-table-bh2 table-mobile-hover"
                            style={{ height: 300 }}
                          >
                            <div className="custom-table-wrapper">
                              <div className="table-headers">
                                <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                                  <p className="text-center">STT</p>
                                </div>
                                <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                                  <p className="text-center">Mã hợp đồng</p>
                                </div>
                                <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                                  <p className="text-center">Ngày vay</p>
                                </div>
                                <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                                  <p className="text-center">Trạng thái</p>
                                </div>
                              </div>
                              <div
                                className="custom-table-body"
                                style={{ height: 250, overflow: "scroll" }}
                              >
                                {dataHDLienKet.map((item, index) => (
                                  <div className="custom-table-row">
                                    <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
                                      <span className="mobile-column-name">
                                        STT
                                      </span>
                                      <div className="center-wrapper">
                                        {index + 1}
                                      </div>
                                    </div>
                                    <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
                                      <span className="mobile-column-name">
                                        Mã hợp đồng
                                      </span>
                                      <div className="center-wrapper">
                                        <p className="text-center">
                                          <span>{item.MaHopDong}</span>
                                        </p>
                                      </div>
                                    </div>

                                    <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
                                      <span className="mobile-column-name">
                                        Ngày vay
                                      </span>
                                      <div className="center-wrapper">
                                        <p className="text-left">
                                          <span>{getDate(item.NgayVay)}</span>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
                                      <span className="mobile-column-name">
                                        Trạng thái
                                      </span>
                                      <div className="center-wrapper">
                                        <p className="text-left">
                                          <span>{item.TrangThai}</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Tab>
                        <Tab
                          eventKey="lichsu"
                          title={<h4 className="nav-link">Lịch sử</h4>}
                        >
                          <div
                            className="table-mobile sticky-table-bh2 table-mobile-hover"
                            style={{ height: 300 }}
                          >
                            <div className="custom-table-wrapper">
                              <div className="table-headers">
                                <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                                  <p className="text-center">STT</p>
                                </div>
                                <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                                  <p className="text-center">Mật khẩu cũ</p>
                                </div>
                                <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                                  <p className="text-center">Mật khẩu mới</p>
                                </div>
                                <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                                  <p className="text-center">Người thay đổi</p>
                                </div>
                                <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                                  <p className="text-center">Ngày thay đổi</p>
                                </div>
                              </div>

                              <div
                                className="custom-table-body"
                                style={{ height: 250, overflow: "scroll" }}
                              >
                                {dataLichSu.map((item, index) => (
                                  <div className="custom-table-row">
                                    <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
                                      <span className="mobile-column-name">
                                        STT
                                      </span>
                                      <div className="center-wrapper">
                                        {index + 1}
                                      </div>
                                    </div>
                                    <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
                                      <span className="mobile-column-name">
                                        Mật khẩu cũ
                                      </span>
                                      <div className="center-wrapper">
                                        <p className="text-center">
                                          <span>{item.MatKhauCu}</span>
                                        </p>
                                      </div>
                                    </div>

                                    <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
                                      <span className="mobile-column-name">
                                        Mật khẩu mới
                                      </span>
                                      <div className="center-wrapper">
                                        <p className="text-left">
                                          <span>{item.MatKhauMoi}</span>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
                                      <span className="mobile-column-name">
                                        Người thay đổi
                                      </span>
                                      <div className="center-wrapper">
                                        <p className="text-left">
                                          <span>{item.NguoiTao}</span>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
                                      <span className="mobile-column-name">
                                        Thời gian
                                      </span>
                                      <div className="center-wrapper">
                                        <p className="text-left">
                                          {item.NgayTao}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Tab>
                      </Tabs>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
